import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import es from './locales/es.json';
import en from './locales/en.json';

i18n
  .use(LanguageDetector) // Detecta el idioma del navegador
  .use(initReactI18next) // Conecta con React
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en }
    },
    supportedLngs: ['es', 'en'],
    nonExplicitSupportedLngs: true,
    fallbackLng: 'en', // Idioma por defecto (webapp-default-language, D1)
    interpolation: {
      escapeValue: false // No necesario en React (ya protege de XSS)
    },
    detection: {
      lookupQuerystring: 'lng', // `?lng=` es el parámetro de entrada en frío (webapp-default-language)
      caches: ['localStorage'], // el idioma resuelto persiste entre visitas
    },
  });

export default i18n;